module.exports = __webpack_public_path__ + "static/img/findworka-talents.4f38cfe.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/findworka-talents.png
// module id = aI9a
// module chunks = 0